var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.96.107a1.86 1.86 0 0 0-1.858 1.858V30.03a1.86 1.86 0 0 0 1.858 1.857h20.301a1.86 1.86 0 0 0 1.857-1.857v-7.968c-.088-.452 0-16.073 0-16.073a.62.62 0 0 0-.18-.438L22.673.29a.62.62 0 0 0-.44-.182zm.206 2.064h15.052v4.192c0 .424.343.768.766.768h4.07v4.749q.002 8.971.001 17.944H6.166z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05 5.128h5.902a.757.757 0 0 0 0-1.514H9.049a.756.756 0 1 0 0 1.514m11.23 2.165a.757.757 0 0 0-.757-.756H9.08a.757.757 0 0 0 0 1.513h10.442a.756.756 0 0 0 .757-.757M9.067 11.078h5.903a.756.756 0 1 0 0-1.514H9.067a.757.757 0 0 0 0 1.514m11.572 5.192-.853-.557a.3.3 0 0 0-.417.087l-4.592 7.027-.883-.577 4.592-7.027a.3.3 0 0 0-.087-.417l-.853-.557a.3.3 0 0 0-.417.087l-6.876 10.522a.3.3 0 0 0-.048.15l-.18 3.652a.3.3 0 0 0 .435.284l3.272-1.63a.3.3 0 0 0 .118-.105l6.876-10.523a.3.3 0 0 0-.087-.416m2.817-4.311-3.092-2.021a.3.3 0 0 0-.417.087l-2.086 3.192a.3.3 0 0 0 .088.416l3.093 2.02a.3.3 0 0 0 .416-.086l2.085-3.192a.3.3 0 0 0-.087-.416",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgbIcon);
export default __webpack_public_path__ + "static/media/AGB_icon.dfb65c1bdd094ddb4ad8a755b120e1e2.svg";
export { ForwardRef as ReactComponent };